var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headline-with-label"},[_c('h4',[_vm._v(_vm._s(_vm.label)+" ")]),_c('h3',{staticClass:"light"},[_vm._v(_vm._s(_vm.headline)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }